import { MenuItem, Typography } from '@mui/material'
import styles from './InviteExternalModal.module.css'
import { t } from 'i18next'
import { Box } from '@mui/system'
import { AppButton, ButtonTheme } from 'components/app-button/AppButton'
import { Input } from 'features/resource/userProfileStylesMui'
import { LangType } from 'common/enums/LangType'
import { ChangeEvent } from 'react'
import { Header } from 'components/header/Header'

interface InviteExternalModalProps {
  inputValue: string
  setInputValue: (value: string) => void
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  language: LangType
  setLanguage: (value: Number | LangType) => void
  handleCloseModal: () => void
}

export default function InviteExternalModal({
  inputValue,
  setInputValue,
  onSubmit,
  language,
  setLanguage,
  handleCloseModal,
}: InviteExternalModalProps) {
  const handleLanguageChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setLanguage(Number(e.target.value))
  }

  return (
    <div className={styles.parentContainer}>
      <form onSubmit={onSubmit}>
        <Box className={styles.newConversationContainer}>
          <Header label={t('externInvite')} />

          <Box className={styles.inputFieldsContainer}>
            <Box>
              <Typography className={styles.inputTitle} variant="h5">
                {t('email')}
              </Typography>
              <Input
                className={styles.textField}
                placeholder={t('email')}
                variant={'outlined'}
                required
                type="email"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </Box>
            <Box>
              <Typography className={styles.inputTitle}>{t('language')}</Typography>
              <Input
                className={styles.textField}
                select
                variant={'outlined'}
                id="language"
                name={'language'}
                value={language}
                label={''}
                onChange={handleLanguageChange}
                required
              >
                <MenuItem value={LangType.Spanish}>{t('spanish')}</MenuItem>
                <MenuItem value={LangType.English}>{t('english')}</MenuItem>
                <MenuItem value={LangType.Italian}>{t('italian')}</MenuItem>
              </Input>
            </Box>
          </Box>
          <Box className={styles.actionsRow}>
            <AppButton
              type={'button'}
              theme={ButtonTheme.NewSecondary}
              label={t('cancel')}
              handler={handleCloseModal}
            />

            <AppButton
              type={'submit'}
              theme={ButtonTheme.NewPrimary}
              label={t('send')}
              handler={() => {}}
            />
          </Box>
        </Box>
      </form>
    </div>
  )
}
